import { ComponentProps } from 'react';
import { PaginatorWithDescription } from '@edu-frontend/modules/src/shared/ui/PaginatorWithDescription';
import { ANSWER_STATUSES } from '../../../constants';

export const getMobileView = (
    status?: ANSWER_STATUSES
): ComponentProps<typeof PaginatorWithDescription>['pages'][number]['status'] => {
    if (status === ANSWER_STATUSES.CORRECT) {
        return 'success';
    }
    if (status === ANSWER_STATUSES.INCORRECT) {
        return 'failure';
    }
    return undefined;
};
